import { render, staticRenderFns } from "./indexHotIndustry.vue?vue&type=template&id=fd8f8bc4&scoped=true&"
import script from "./indexHotIndustry.vue?vue&type=script&lang=js&"
export * from "./indexHotIndustry.vue?vue&type=script&lang=js&"
import style0 from "./indexHotIndustry.vue?vue&type=style&index=0&id=fd8f8bc4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8f8bc4",
  null
  
)

export default component.exports